<template>
  <v-container>
    <v-layout>
      <v-flex wrap xs12 sm8 offset-sm-2 md6 offset-md-3 lg4 offset-lg-4>
        <h1 class="display-2 font-weight-bold mb-3 text-center primary--text">
          Arrival Subscriptions
        </h1>
        <v-layout :column="$vuetify.breakpoint.xs" justify-center align-center mb-4>
          <v-btn solid
                 color="secondary"
                 to="/login"
                 width="200"
                 class="ma-2">Log in now</v-btn>
          <v-btn solid
                 color="primary"
                 to="/register"
                 width="200"
                 class="ma-2">Create an account</v-btn>
        </v-layout>
        <p>
          If you regularly commute using our transit system, you can get notifications when a bus/ferry/train is approaching the stop you usually board at, at the times when you need.
        </p>
        <p>
          To begin, navigate to your stop on <a target="_parent" href="/rtt/public/transit.aspx?page=map">our map</a>
          <br /> If you are a mobile user, simply long press on the stop or station
          <br /> If you are on a larger device, when you open a stop's ETA box, click on the glowing <v-icon color="secondary">add_box</v-icon>
        </p>
        <img src="@/assets/add_sub_help.png" class="ma-3" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({

  }),
};
</script>
